import LoanApplicationModal from "../../shared/LoanApplicationModal";
import CustomInput from "../../shared/CustomInput";
import CustomSelect from "../../shared/CustomSelect";

const IncomeDetails = ({
  closeIcomeInformation,
  activeIndex,
  handleNextStep,
  incomeDetails,
  setIncomeDetails,
  loading,
}) => {
  return (
    <LoanApplicationModal
      closeBioInformation={closeIcomeInformation}
      activeIndex={activeIndex}
      handleNextStep={handleNextStep}
      loading={loading}
    >
      <p className="text-[#000000] font-normal text-[14px]">
        Create a New Loan Application
      </p>
      <p className="text-[#000000] font-semibold text-[20px]">
        Borrower’s Income Details
      </p>
      <p className="text-[#5C5C5C] text-[14px] font-normal">
        Enter borrowers income details
      </p>
      <div className="h-[490px] overflow-y-auto">
        <div className="flex items-start gap-[20px] my-[10px]">
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Source of Income"
            >
              Source of Income*
            </label>
            <CustomSelect
              name="Source of Income"
              value={incomeDetails?.sourceOfIncome}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  sourceOfIncome: e.target.value,
                })
              }
              options={[
                "Self employment",
                "Employed",
                "Employed with a business",
              ]}
            />
          </div>
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="KRA PIN"
            >
              KRA PIN
            </label>
            <CustomInput
              placeholder="Enter your KRA PIN"
              type="text"
              value={incomeDetails?.kraPin}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  kraPin: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="flex items-start gap-[20px] my-[20px]">
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Business Name"
            >
              Business Name
            </label>
            <CustomInput
              placeholder="Enter your business name"
              type="text"
              value={incomeDetails?.businessName}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  businessName: e.target.value,
                })
              }
            />
          </div>
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Years of Operation"
            >
              Years of Operation
            </label>
            <CustomInput
              placeholder="Enter years of operation"
              type="text"
              value={incomeDetails?.yearsOfOperation}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  yearsOfOperation: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="flex items-start gap-[20px] my-[10px]">
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Type of Business"
            >
              Type of Business
            </label>
            <CustomSelect
              name="Type of Business"
              value={incomeDetails?.typeOfBusiness}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  typeOfBusiness: e.target.value,
                })
              }
              options={["Sole Propreitorship", "Partnership", "Company"]}
            />
          </div>
        </div>
        <div className="flex items-start gap-[20px] my-[20px]">
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Licenses Required for this Type of Business"
            >
              Licenses Required for this Type of Business
            </label>
            <CustomInput
              placeholder="Enter licenses required for this type of business"
              type="text"
              value={incomeDetails?.businessLicense}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  businessLicense: e.target.value,
                })
              }
            />
          </div>
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Risks Associated with this Type of Business"
            >
              Risks Associated with this Type of Business
            </label>
            <CustomInput
              placeholder="Enter risks associated with this type of business"
              type="text"
              value={incomeDetails?.risksAssociated}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  risksAssociated: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="flex items-start gap-[20px] my-[10px]">
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Strengths Associated with this Type of Business"
            >
              Strengths Associated with this Type of Business
            </label>
            <CustomInput
              placeholder="Enter strengths associated with this type of business"
              type="text"
              value={incomeDetails?.strengthOfBusiness}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  strengthOfBusiness: e.target.value,
                })
              }
            />
          </div>
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Business Stability"
            >
              Business Stability
            </label>
            <CustomInput
              placeholder="Enter business stability"
              type="text"
              value={incomeDetails?.levelOfStability}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  levelOfStability: e.target.value,
                })
              }
            />
          </div>
        </div>
        <p className="text-[#222222] text-[15px] my-[15px] font-medium">
          Employment Details
        </p>
        <div className="flex items-start gap-[20px] my-[10px]">
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Employer Name"
            >
              Employer Name
            </label>
            <CustomInput
              placeholder="Enter employer name"
              type="text"
              value={incomeDetails?.employerName}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  employerName: e.target.value,
                })
              }
            />
          </div>
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Monthly Income"
            >
              Monthly Income
            </label>
            <CustomInput
              placeholder="Enter monthly income"
              type="text"
              value={incomeDetails?.monthlyIncome}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  monthlyIncome: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="flex items-start gap-[20px] my-[10px]">
          <div className="flex w-[48%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Duration at Employer"
            >
              Duration at Employer
            </label>
            <CustomSelect
              name="Duration at employer"
              placeholder="Enter duration at employer"
              options={["1-3 years", "2-3 years", "Over 5 years"]}
              value={incomeDetails?.durationAtEmployer}
              onChange={(e) =>
                setIncomeDetails({
                  ...incomeDetails,
                  durationAtEmployer: e.target.value,
                })
              }
            />
          </div>
        </div>
      </div>
    </LoanApplicationModal>
  );
};

export default IncomeDetails;
